<template>
  <div>
    <div class='page'>
      <div class='main'>
        <section class='content'>
          <section class="w-full flex justify-center">
            <form class='search flex' @submit.prevent='onSubmit()'>
              <div class='input-container w-full flex'>
                <div class="w-full flex search__wrapper items-center" aria-label="search container">
                  <img src="@/assets/svg/search.svg" alt="Search Icon" />
                  <input v-model="newSearch" type="search" placeholder="Ask a question" name="" id="" class="w-2/3 h-full">
                  <button :disabled="!value" class="flex justify-center items-center h-full capitalize">search</button>
                </div>
                <!-- <k-input v-model='value' label='' reactive type='search'></k-input>
                <k-button :disabled='!value' short submit type='submit' ref='searchBtn'>
                  Search
                </k-button> -->
                <!-- <ul :class='["search-suggestions top-24", { loading: isSearching }]'>
                  <div v-if='isSearching'>
                    <div class='lds-default'>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <template v-else>
                    <li v-for='searchTerm in sortedSuggestions' :key='searchTerm' tabindex='0' @click='$router.push({
                      name: "Results",
                      query: { q: encodeURIComponent(searchTerm) }
                    })'>
                      {{ searchTerm }}
                    </li>
                  </template>
                </ul> -->
              </div>

            </form>
          </section>
          <div v-show='!relatedQuerySearches.length' class='flex justify-center flex-col items-center'>
            <h3 class="no__search">Sorry, we could not find any result for “{{ value }}”</h3>
            <img src="@/assets/svg/no-search.svg" alt="Search Icon" />
          </div>
          <div v-show='relatedQuerySearches.length' class='flex justify-center flex-col items-center'>
            <h3 class="no__search">Sorry, we could not find any result for “{{ value }}”</h3>
            <img src="@/assets/svg/no-search.svg" alt="Search Icon" />
          </div>
          <div class='results'>
            <template v-if='loading'>
              <div class='desktop-left'>
                <section>
                  <h3 class="text-brandCol search__header">Related searches</h3>
                  <div v-for='i in [1, 2]' :key='i' class='result'>
                    <div class='tags'>
                      <div class='suspense mh-10 w-50'></div>
                    </div>
                    <div class='title'>
                      <div class='suspense mh-20 w-70'></div>
                    </div>
                    <div class='description'>
                      <div class='suspense mh-10 mb'></div>
                      <div class='suspense mh-10 mb'></div>
                      <div class='suspense mh-10 mb'></div>
                    </div>
                  </div>
                </section>
                <!-- <section>
                  <h3 class="text-brandCol search__header">Related searches</h3>
                  <div v-for='i in [1, 2, 3]' :key='i' class='result'>
                    <div class='tags'>
                      <div class='suspense mh-10 w-50'></div>
                    </div>
                    <div class='title'>
                      <div class='suspense mh-20 w-70'></div>
                    </div>
                    <div class='description'>
                      <div class='suspense mh-10 mb'></div>
                      <div class='suspense mh-10 mb'></div>
                      <div class='suspense mh-10 mb'></div>
                    </div>
                  </div>
                </section> -->
              </div>
            </template>

            <template v-else>
              <div class='desktop-left'>
                <section class='relevant' v-show='relatedQuerySearches.length'>
                  <h3 class="text-brandCol search__header">Related searches</h3>
                  <div v-for='(r, idx) in relatedQuerySearches' :key='idx' class='result'>
                    <div class='tags'>{{
                      `indicators ‣ ${r.metadata.category} ‣ ${r.search}`
                      }}
                    </div>
                    <div class='title' @click='listenForClicks'>
                      <router-link
                        :to='`/indicators/${encodeURIComponent(r.search)}/?category=${encodeURIComponent(r.metadata.category)}`'>
                        {{ r.search }}
                      </router-link>
                      <!-- <router-link
                        :to='`/indicators/${encodeURIComponent(r.search)}/${encodeURIComponent(r.metadata.country)
                        }?category=${encodeURIComponent(r.metadata.category)}&frequency=${encodeURIComponent(r.metadata.frequency)}`'>
                        {{ r.search }}
                      </router-link> -->
                      <!-- <span v-if='datasetId(r)' class='chart'>{{ r.metadata.frequency }}</span> -->
                    </div>
                    <div class='description'>
                      {{ r.desc }}
                    </div>
                  </div>
                </section>
                <section v-if='dashboard.id' class='country-dashboard'>
                  <h3 class="text-brandCol search__header">Country Dashboard</h3>
                  <div class='country'>
                    <h1 class='name'>{{ titleCase(dashboard.name) }}</h1>
                    <img :src='dashboard.imageUrl' alt='' class='image'>
                    <div class='description'>
                      {{ dashboard.description }}
                    </div>
                    <router-link :to="{ name: 'CountryDashboard', params: { country: dashboard.name } }"
                      class="flex items-center justify-end btn-link btn-link-secondary rounded-full">
                      <span id="btn-text-2">Overview</span>
                      <div class="btn-inner bg-brandCol flex items-center justify-center rounded-full">
                        <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
                      </div>
                    </router-link>
                  </div>
                </section>
                <!-- <section class='related' v-show='relatedResults.length'>
                  <h3 class="text-brandCol search__header">Related Results</h3>
                  <div v-for='(r) in relatedResults' :key='r.indicatorId' class='result'>
                    <div class='tags'>{{
                      `indicators ‣ ${r.category} ‣ ${r.indicatorName}`
                    }}
                    </div>
                    <div class='title' @click='listenForClicks'>
                      <router-link
                        :to='`/indicators/${encodeURIComponent(r.indicatorName)}/${encodeURIComponent(r.country)}?category=${encodeURIComponent(r.category)}&frequency=${encodeURIComponent(r.frequency)}`'
                        @click="$emit('clickedMore')">
                        {{ `${titleCase(r.country)}: ${r.indicatorName}` }}
                      </router-link>
                      <span v-if='datasetId(r)' class='chart'>{{ r.frequency }}</span>
                    </div>
                    <div class='description'>
                      {{ r.notes }}
                    </div>
                  </div>
                </section>
                <section class='popular-searches'>
                  <h3 class="text-brandCol search__header">People also searched for</h3>
                  <ul class='phrases'>
                    <li v-for='phrase in relatedSearches' :key='phrase[0]' @click='search(phrase[0])'>
                      {{ phrase[0] }}
                    </li>
                  </ul>
                </section> -->
              </div>
              <div class='desktop-right'>
                <section v-if='dashboard.id' class='country-dashboard only-on-desk'>
                  <h3 class="text-brandCol search__header">Country Dashboard</h3>
                  <div class='country'>
                    <h1 class='name text-brandCol'>{{ titleCase(dashboard.name) }}</h1>
                    <img :src='dashboard.imageUrl' alt='' class='image'>
                    <div class='description'>
                      {{ dashboard.description }}
                    </div>
                    <router-link :to="{ name: 'CountryDashboard', params: { country: dashboard.name } }"
                      class="flex items-center justify-end btn-link btn-link-secondary rounded-full">
                      <span id="btn-text-2">Overview</span>
                      <div class="btn-inner bg-brandCol flex items-center justify-center rounded-full">
                        <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
                      </div>
                    </router-link>
                  </div>
                </section>
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
    <Footer />
    <div v-if="formLoading" class="absolute top-0 z-10 h-full w-full custom-bg flex flex-col justify-center items-center">
      <div class="suspense flex justify-center items-center">
        <p class="text-black">Loading....</p>
      </div>
    </div>
  </div>
</template>

<script>
import Results from './Results';

export default Results;
</script>

<style lang='scss' scoped src='./Results.scss'></style>
